import { render, staticRenderFns } from "./ProductsQuotationModal.vue?vue&type=template&id=82ddce3e&scoped=true&"
import script from "./ProductsQuotationModal.vue?vue&type=script&lang=js&"
export * from "./ProductsQuotationModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductsQuotationModal.vue?vue&type=style&index=0&id=82ddce3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ddce3e",
  null
  
)

export default component.exports